import { AxiosResponse } from "axios";
import { axiosInstance }
	from "./axiosInstance"
import { AdvisorCandidateDTO, AdvisorSelection, EnrollmentHistoryDTO } from "../../models/EnrollmentHistoryDTO";

export class EnrollmentService {

	async searchEnrollments(campusId: number, scheduleId: number) {
		const URL: string = `/admin/
            campus/${campusId}/
            schedules/${scheduleId}/
            _students`.replace(/\s+/g, "");
		const response = await axiosInstance.get(URL);
		return response;
	}

	/** People who can be credited as asesora of an enrollment in this campus. */
	async getAdvisorCandidates(campusId: number): Promise<AxiosResponse<AdvisorCandidateDTO[]>> {
		return axiosInstance.get<AdvisorCandidateDTO[]>(`/admin/campus/${campusId}/enrollments/_advisorCandidates`);
	}

	/** Replace the advisors of an enrollment (restricted server-side to supervisors / sales direction). */
	async updateAdvisors(campusId: number, studentId: number, enrollmentId: number, advisors: AdvisorSelection[]): Promise<AxiosResponse> {
		const payload = {
			advisors: advisors.map((advisor) => ({ userId: advisor.userId, sharePercentage: advisor.sharePercentage }))
		};
		return axiosInstance.put(`/admin/campus/${campusId}/students/${studentId}/enrollments/${enrollmentId}/_advisors`, payload);
	}

	/** Every enrollment of the student with who/when, advisors, notes and attendance summary. */
	async getStudentHistory(campusId: number, studentId: number): Promise<AxiosResponse<EnrollmentHistoryDTO[]>> {
		return axiosInstance.get<EnrollmentHistoryDTO[]>(`/admin/campus/${campusId}/students/${studentId}/_history`);
	}
}